import React from 'react';
import '../App.css';

function FormSection({ title, header_action, children }) {
	return (
		<div className="admin-form-section">
			{header_action ? (
				<div className="admin-persona-fields-header">
					<h6 className="admin-form-section-title">{title}</h6>
					{header_action}
				</div>
			) : (
				<h6 className="admin-form-section-title">{title}</h6>
			)}
			{children}
		</div>
	);
}

export default FormSection;
